"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _BannerProductListingSkeleton = require("./BannerProductListingSkeleton");
Object.keys(_BannerProductListingSkeleton).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _BannerProductListingSkeleton[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _BannerProductListingSkeleton[key];
        }
    });
});
